(() => {
  class EdelmanLuxuryMenu {
    constructor(root) {
      this.root = root;
      this.trigger = document.querySelector('[data-ew32-menu-trigger]');
      this.headerSection = document.querySelector('.section-header');
      this.previouslyFocused = null;
      this.open = false;

      if (!this.trigger) return;

      this.onTrigger = this.onTrigger.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onResize = this.updateTop.bind(this);
      this.onLinkClick = this.onLinkClick.bind(this);

      this.trigger.addEventListener('click', this.onTrigger);
      this.root.addEventListener('click', this.onLinkClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('scroll', this.onResize, { passive: true });

      document.querySelectorAll('.ew32-header .header__search summary').forEach((summary) => {
        summary.addEventListener('click', () => this.close());
      });

      this.updateTop();
    }

    updateTop() {
      if (!this.headerSection) return;
      const bottom = Math.max(0, this.headerSection.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--ew32-menu-top', `${Math.round(bottom)}px`);
    }

    onTrigger() {
      this.open ? this.close() : this.show();
    }

    show() {
      if (this.open) return;
      this.open = true;
      this.previouslyFocused = document.activeElement;
      this.updateTop();
      this.root.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ew32-menu-open');

      const firstTarget = this.getFocusable()[0];
      window.setTimeout(() => firstTarget?.focus({ preventScroll: true }), 80);
    }

    close() {
      if (!this.open) return;
      this.open = false;
      this.root.setAttribute('aria-hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ew32-menu-open');
      this.previouslyFocused?.focus?.({ preventScroll: true });
    }

    onLinkClick(event) {
      const link = event.target.closest('a');
      if (link) this.close();
    }

    onKeydown(event) {
      if (!this.open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = this.getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    getFocusable() {
      return Array.from(
        this.root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null);
    }
  }

  const init = () => {
    document.querySelectorAll('[data-ew32-luxury-menu]').forEach((menu) => {
      if (!menu.dataset.ew32Initialized) {
        menu.dataset.ew32Initialized = 'true';
        new EdelmanLuxuryMenu(menu);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
